export const css = {
	root: '_1A0aCine',
	inputWrapper: '_2PaicBlV',
	label: '_3iC8DYGi',
	thumb: '_13QS0REW',
	track: '_25wVCmOW',
	underlay: '_1Vn5BkmC',
	nativeControl: 'VamPmTC8',
	checked: '_1LvjMRt1',
	disabled: '_1Oj0AsUR',
	readonly: '_1JHNK7j0',
	focused: 'npYUex1Y',
	offLabel: '_1QOiH-SQ',
	onLabel: '_23eNOT-b',
	' _key': 'apic-theme/dojo/switch'
};

export default css;
